module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3115093c9dad31d285a8a694a06cced0.png";